import { Component, OnInit, Input } from '@angular/core';

import { UXPage, UXBlocksGroup } from '../../../core/models/ux-page';
import { Crumb } from '../../../core/models/crumb';

@Component({
  selector: 'app-page-page',
  templateUrl: './page-page.component.html',
  styleUrls: ['./page-page.component.scss']
})
export class PagePageComponent implements OnInit {
  @Input() page: UXPage;


  constructor() { }

  ngOnInit() {
  }

  get pageFound(): boolean {
    return !!this.page
  }

  get hasVideos(): boolean {
    if (this.page && this.page.videos && this.page.videos.length) {
      return true
    }
    return false
  }

  get videoUrl(): string {
    return this.page.videos[0].videoUrl
  }

  get videoQuery(): any {
    return this.page.videos[0].query
  }

  get videoAttr(): any {
    return this.page.videos[0].attr
  }

  get hasPageDecoration(): boolean {
    return this.page &&
      ((!!this.page.banner && !!this.page.banner.img)
        || !!this.page.blocks.length
        || !!this.page.introText)
  }

  get hasBlocksGroups(): boolean {
    if (this.page && this.page.blocksGroups && this.page.blocksGroups.length) {
      return true
    }
    return false
  }

  get blocksGroups(): UXBlocksGroup[] {
    return this.page.blocksGroups
  }
}
